/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

/**
 * プレイリスト文脈付きの場合のプレイリストID @example "cmmd80xkh000n0w01dxd7hfbv"
 * @nullable
 */
export type ShortLinkTargetScenarioId = Cuid | null
